import { render } from "./outside-click.vue?vue&type=template&id=955a158a&ts=true"
import script from "./outside-click.vue?vue&type=script&lang=ts"
export * from "./outside-click.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__